import React from "react";
import { VStack } from "@chakra-ui/react";
import { useSessionCtx, noop, isNilOrEmpty } from "utils";
import ContentContainer from "components/Container";
import { IFrameFooterWithLogo } from "components/Footer";
import { Error } from "components/Error";

export const IFrame = ({ Provider, config = {}, onComplete, onReady = noop, header }) => {
  const { debug } = useSessionCtx();

  // if config does not have 'provider', the use default.
  // if provider exists but does not have a resolvable value,
  // treat as an error
  if (isNilOrEmpty(Provider)) {
    debug("ERROR - Invalid provider:", config.provider);
    return <Error />;
  }

  const handleComplete = (result) => onComplete({ state: "complete", id: result });

  const handleCancel = () => onComplete({ state: "cancel" });

  return (
    <ContentContainer>
      <VStack spacing={5} align="stretch">
        {header}
        <Provider
          onCancel={handleCancel}
          onComplete={handleComplete}
          onReady={onReady}
          hideCancelButton={true}
          config={config}
        />
      </VStack>
      <IFrameFooterWithLogo />
    </ContentContainer>
  );
};
